import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.wallets.kyc.PersonIdDocument', {
    idDocument: 'ID document',
    pleaseProvideDocs: 'Please provide a color photo of the selected Document',
    docType: 'Document type',
    docTypePlaceholder: 'Select document type...',
    front: 'Front side',
    back: 'Back side',
    requirements: 'JPG, PNG, PDF. Max 10 Mb',
    requiredField: 'Field is required',
    documentRequired: 'Document is required',
});
